import type { FormRule } from 'antd';
import { CONTAINER_SIZES } from 'shared/constants/container-sizes';
import { isSafeIntValidator } from 'shared/utils/validators/is-safe-integer-validator';

export const rules: Record<string, FormRule[]> = {
  type: [{ required: true, message: 'Container type is required' }],
  weight: [{ type: 'integer', min: 1, message: 'Weight must be a positive integer' }, ...isSafeIntValidator('Weight')],
};

export const containerTypeOptions = Object.keys(CONTAINER_SIZES).map((type) => ({ value: type, label: type }));
